import React from 'react';
import LocationUtil from '../../utils/locationutil.js';

class LocationBar extends React.Component {

	render() {

		var locationName = this.props.location || 'Unknown';
		const amountLabel = "$" + (this.props.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '0.00');

		if(Array.isArray(locationName)) {
			var locationsArray = [];
			for(var locKey = 0; locKey !== locationName.length; locKey++) {
				var location = locationName[locKey];

				const locationObj = LocationUtil.getLocationByLabel(location);
				var locationJSX = '';

				if(locKey !== locationName.length - 1) {
					locationJSX = (
						<div key={"location-" + locKey} className="LocationBar-Nav">
							<a href={locationObj.link}>{location}</a>
						</div>
					);
				}
				else {
					locationJSX = (
						<div key={"location-" + locKey} className="LocationBar-Nav">
							{location}
						</div>
					);
				}

				locationsArray.push(locationJSX);
			}

			locationName = (
				<div className="LocationBar-Array">
					{locationsArray}
				</div>
			);
		}
		return (
			<div className="App-LocationBar">
				<div className="Location">{locationName}</div>
				<div className="TotalSaved"> Total Saved</div>
				<div className="AmountSaved">{amountLabel}</div>
			</div>
		);
	}
}

export default LocationBar;